import styled from "styled-components";

export const TransferDetailModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  p {
    font-size: 1.5rem;
    font-weight: 600;
  }
`;
